import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-mt-2 p-mb-2 p-p-2 content" }
const _hoisted_2 = { class: "p-fluid p-component p-formgrid p-grid p-input-filled" }
const _hoisted_3 = { class: "p-field p-col-12" }
const _hoisted_4 = { for: "batchClassId" }
const _hoisted_5 = { class: "p-mt-2 p-ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Mail = _resolveComponent("Mail")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_MailForm = _resolveComponent("MailForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Squeeze.BatchClasses.BatchClass')), 1),
          _createVNode(_component_Dropdown, {
            id: "batchClassId",
            modelValue: _ctx.batchClassId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batchClassId) = $event)),
            options: _ctx.batchClasses,
            loading: _ctx.loading,
            optionValue: "id",
            optionLabel: "description",
            onChange: _ctx.onChangeBatchClass
          }, null, 8, ["modelValue", "options", "loading", "onChange"])
        ])
      ]),
      _createVNode(_component_Mail, {
        mails: _ctx.mails,
        loading: _ctx.loading,
        documentClasses: _ctx.documentClasses,
        showErrorMessage: _ctx.showValidationMessage,
        showAuthenticateButtonColumn: _ctx.showAuthenticateButtonColumn,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnEntrySelect: _ctx.onEntrySelect,
        onTestMailConnection: _ctx.testMailConnection,
        onFetchMails: _ctx.fetchMails
      }, null, 8, ["mails", "loading", "documentClasses", "showErrorMessage", "showAuthenticateButtonColumn", "onOnClickDelete", "onOnEntrySelect", "onTestMailConnection", "onFetchMails"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveMail,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.mail.id
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_MailForm, {
              ref: "mailForm",
              mail: _ctx.mail,
              batchClassId: _ctx.mail.batchClassId,
              batchClasses: _ctx.batchClasses,
              documentClasses: _ctx.documentClasses,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["mail", "batchClassId", "batchClasses", "documentClasses", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showFeedbackDialog,
      onOnConfirm: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showFeedbackDialog = false)),
      onOnClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showFeedbackDialog = false)),
      headerText: _ctx.headerFeedbackText,
      saveButtonText: 'OK',
      showAbortButton: false
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.headerFeedbackText === _ctx.$t('Squeeze.General.Success') ? 'mdi mdi-progress-check icon-success' : 'mdi mdi-progress-close icon-error')
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(_ctx.feedbackMessage) + " ", 1),
          _createElementVNode("div", _hoisted_5, "Mail ID: " + _toDisplayString(_ctx.feedbackMailId), 1)
        ])
      ]),
      _: 1
    }, 8, ["show", "headerText"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showAuthenticateDialog,
      onOnConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.startAuthenticate(_ctx.authenticateMailId))),
      onOnClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showAuthenticateDialog = false)),
      headerText: _ctx.$t('Squeeze.System.Warning'),
      saveButtonText: _ctx.authenticateMailId ? _ctx.$t('Squeeze.Imports.StartAuthentication') : 'OK',
      showAbortButton: !!_ctx.authenticateMailId
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "mdi mdi-alert-circle-outline icon-warning" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.authenticateMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["show", "headerText", "saveButtonText", "showAbortButton"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showTestMailConnectionDialog,
      onOnConfirm: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showTestMailConnectionDialog = false)),
      onOnClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showTestMailConnectionDialog = false)),
      headerText: _ctx.$t('Squeeze.Imports.SuccessEmailConnection'),
      saveButtonText: 'OK',
      showAbortButton: false
    }, {
      content: _withCtx(() => [
        _createElementVNode("span", null, [
          _cache[10] || (_cache[10] = _createElementVNode("i", { class: "mdi mdi-email-search-outline icon-success" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.messageTestMailConnectionDialog), 1)
        ])
      ]),
      _: 1
    }, 8, ["show", "headerText"])
  ], 64))
}